export const SignatureQueryKey = (id_client: string | undefined) => ['signature', id_client]
export const signatureClientKey = (id?: string) => ['signature:client', id] as const
export const signatureUserKey = (id?: string) => ['signature:user', id] as const
